import React, { useState } from 'react';
import { GetDealer } from './../Services/MyDealer.service';

const MyDealerButton = ({
  cssClass,
  isAuth,
  cssLoadingClass,
  label,
  isMyDealerLabel,
  dealerId,
  disableDealerBtn,
  disabledCssClass,
}) => {
  const isBtnExist = isAuth === 'True';
  const disableDealerBool = disableDealerBtn === 'True';
  const [disableDealer, setDisableDealer] = useState(disableDealerBool);
  const [cssClassName, setCssClassName] = useState(
    disableDealer ? disabledCssClass : cssClass
  );
  const [text, setText] = useState(disableDealer ? isMyDealerLabel : label);
  const [loading, setLoading] = useState(false);
  const onClick = async () => {
    if (!disableDealer) {
      setText();
      setLoading(true);
      setCssClassName(cssLoadingClass);
      await GetDealer(dealerId);
      setLoading(false);
      setDisableDealer(true);
      setCssClassName(disabledCssClass);
      setText(isMyDealerLabel);
    }
  };
  return isBtnExist ? (
    <button
      className={cssClassName}
      type="button"
      disabled={disableDealer}
      onClick={onClick}
    >
      {text}
    </button>
  ) : null;
};

export default MyDealerButton;
